(ns guidebook.views.priority-actions
  (:require
    [reagent.core :as r]
    [guidebook.common :refer [title-s body-s]]
    [cljss.core :as cljss]
    [css.core :refer [defstyled get-theme]]
    [util.core :refer [long-str]]
    [very.re-frame.core :as rf]))

(defstyled priority-actions-s :div
  {:min-height "100vh"
   :display "grid"
   :grid-template-columns "5fr 3fr"
   ::cljss/media {[:print]
                  {:grid-template-columns "1fr"}}})

(defstyled h2-s :h2
  {:font-size "3.125rem"
   :font-weight "300"
   :color "white"
   :margin "0 0 2rem"
   ::cljss/media {[:print]
                  {:font-size "2.25rem"
                   :line-height "3.125rem"
                   :-webkit-margin-before 0
                   :-webkit-margin-after 0
                   :margin "0 0 1rem"}}})

(defstyled list-s :ul
  {:list-style "disc"
   :margin "0 0 0 2rem"
   :color "white"
   ::cljss/media {[:print]
                  {:margin "0 0 0 2rem"
                   :padding "0"
                   :list-style-position "inside"}}})

(defstyled list-item-s :li
  {:margin "1rem 0 0 0"
   :font-size "1.5625rem"
   :list-style-position "outside"
   :&:first-child {:margin-top "0"}
   ::cljss/media {[:print]
                  {:&:first-child {:margin-top "0"}}}})

(defstyled ol-s :ol
  {:margin "4rem 0 0"
   :display "grid"
   :grid-template-columns "1fr 1fr"
   :grid-gap "2rem 4rem"
   :list-style-type "decimal"})

(defstyled ol-li-s :li
  {:margin "0 0 0 2rem"
   :font-size "1.5625rem"
   :font-weight 500
   :line-height "2.25rem"})

(defstyled info-s :section
  {:background "black"
   :padding "100px"
   :margin-right "50px"
   ::cljss/media {[:print]
                  {:background "none"
                   :display "grid"
                   :grid-template-columns "1fr"
                   :grid-template-rows "min-content"
                   :align-items "flex-start"
                   :padding "100px 0 0"
                   :margin "0"}}})

(defstyled actions-s :section
  {:padding "135px 100px"
   ::cljss/media {[:print]
                  {:padding "135px 100px 0"}}})

(defstyled true-wealth-s :div
  {:margin "3rem 0 0"
   ::cljss/media {[:print]
                  {:background (get-theme :primary)
                   :position "relative"
                   :top "-50px"
                   :z-index "1"
                   :padding "100px"}}})

(defn main []
  (let [priority-actions (rf/subscribe [:guidebook/cases])]
    (fn []
      (let [actions-ordered (if @priority-actions (reverse @priority-actions) nil)]
        [priority-actions-s
         [actions-s
          [title-s "Priority Actions"]
          [body-s "Your Personalized Game Plan is a living document focused on pursuing your goals. The action items discussed are listed below and will be added to your online account. We will hold each other accountable for completing outstanding tasks and track until these items are completed."]
          (into [ol-s
                 (for [a actions-ordered]
                   ^{:key (random-uuid)}
                   [ol-li-s
                    [body-s {:margin "0 0 0 2rem"} (:description a)]])])]
         [info-s
          [true-wealth-s
           [h2-s "What is True Wealth?"]
           [body-s {:color "white"} "True Wealth is everything money can't buy and death can't take away. Once you've finalized your financial plan, you're on track to living your life by design — not by default. Pursue your True Wealth today!"]]]]))))
